import { useQuery } from '@tanstack/react-query';
import { planResourcesService } from '@/services/plan-resources';
import type { PlanResourceDetail } from '@/services/plan-resources/types';

export function usePlanResourcesByCode(code?: string) {
  return useQuery({
    queryKey: ['plan-resources-by-code', code],
    enabled: Boolean(code),
    queryFn: async (): Promise<PlanResourceDetail[]> => {
      const result = await planResourcesService.getByPlan(code as string);
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar recursos do plano');
      }
      return result.data;
    },
  });
}
